<template>
  <div class="account">
    <h3>销户</h3>
    <div class="accountOne" v-if="!accountShow">
      <div class="account_mess">
        <h4>继续操作前，请阅读一下信息：</h4>
        <ul>
          <li>
            宁夏工业企业数字化转型公共服务平台账户{{
              telephone
            }}将被彻底删除，并且无法恢复。
          </li>
          <li>
            宁夏工业企业数字化转型公共服务平台服务、宁夏工业企业数字化转型公共服务平台下小程序应用中所有的个人数据都将永久删除。
          </li>
          <li>
            被删除的个人数据包括但不限于宁夏工业企业数字化转型公共服务平台的所有文档、照片等内容；与本账号关联的第三方服务相关的数据。
          </li>
        </ul>
        <!-- <a href="#" download="w3logo">删除前请下载此账号相关的个人数据</a> -->
        <span>提示：删除前请自行下载此账号相关的个人数据</span>
      </div>
      <div class="account_mess_num" v-if="userPrompt">
        <h4>销户前请处理以下事项，再重新提交申请：</h4>
        <div class="account_mess_title" v-if="orderType.buyerOrder">
          <h4>宁夏工业企业数字化转型公共服务平台买家</h4>
          <p>您还有未结束的订单请前往买家工作台进行处理；</p>
        </div>
        <div class="account_mess_title" v-if="orderType.designerOrder">
          <h4>宁夏工业企业数字化转型公共服务平台设计师</h4>
          <p>您还有未结束的订单请前往设计师工作台进行处理；</p>
        </div>
        <div class="account_mess_title" v-if="orderType.sellerOrder">
          <h4>宁夏工业企业数字化转型公共服务平台卖家</h4>
          <p>您还有未结束的订单请前往卖家工作台进行处理；</p>
        </div>
        <!-- <div class="account_mess_title">
          <h4>宁夏工业企业数字化转型公共服务平台水泵课堂</h4>
          <p>您的水泵课堂有未结束的订单，请前往学习中心进行处理。</p>
        </div> -->
        <div class="account_mess_title" v-if="orderType.appletOrder">
          <h4>宁夏工业企业数字化转型公共服务平台人像定制小程序</h4>
          <p>
            宁夏工业企业数字化转型公共服务平台人像定制小程序、水泵文创产品交易小程序、砂游记小程序的未结束的订单，请前往小程序个人中心处理。
          </p>
        </div>
        <div class="account_mess_ti">
          <i class="el-icon-info"></i>
          <p>您有未处理事项，请处理后继续销户。</p>
        </div>
      </div>
      <el-form
        :model="checkedForm"
        :rules="checkedRules"
        ref="checkedFormRef"
        label-width="0px"
        class="demo-ruleForm"
      >
        <el-form-item prop="type">
          <div class="account_mess_check">
            <el-checkbox-group v-model="checkedForm.type">
              <el-checkbox name="type">我已阅读并同意</el-checkbox>
            </el-checkbox-group>
            <p class="account_mess_checkP" @click="protocolDetails">
              《<span>注销协议</span>》
            </p>
          </div>
        </el-form-item>
      </el-form>
      <div class="account_mess_btn">
        <el-button @click="applyAccount" class="zhuxiao">申请注销</el-button>
        <el-button @click="applyAccountNo" type="primary" class="quxiao"
          >取消</el-button
        >
      </div>
    </div>

    <div class="accountTwo" v-if="accountShow">
      <div class="account_mess_warn">
        <i class="el-icon-info"></i>
        账号注销操作，该账号将被彻底删除，且无法恢复。
      </div>
      <div class="accountTwo_tel">
        <h2>{{ telephone }}</h2>
        <div class="registered_validation2 flex" v-if="vcodes">
          <i class="el-icon-check"></i>
          <p>验证成功</p>
        </div>
        <div class="registered_validation flex" @click="getValidation" v-else>
          <img src="../../../assets/validation.png" alt="" />

          <p>点击按钮开始安全验证</p>
          <Vcode
            :show="validation"
            @success="onValidation('yes')"
            @fall="onValidation('no')"
            @close="onClose"
            :imgs="imgUrls"
          />
        </div>
        <div class="accountTwo_tel_num">
          <input type="text" placeholder="请输入短信验证码" v-model="smsCode" />
          <el-button type="text" @click="getCountdown" v-if="canClick"
            >获取短信验证码</el-button
          >
          <span v-else tyle="color: #b5b5b5">{{ timeClock }}s</span>
        </div>
        <p class="accountTwo_telP">
          *为了您的账户安全，请输入发送给该账号的验证码
        </p>
      </div>
      <div class="accountTwo_btn">
        <el-button type="primary" @click="applyAccountNo">取消</el-button>
        <el-button @click="onClickCellation">下一步</el-button>
      </div>
    </div>

    <!-- 协议内容 -->
    <el-dialog title="注销协议" :visible.sync="dialogTableVisible">
      <div v-html="content" class="vHtmlMess"></div>
    </el-dialog>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex"
import {
  getSmscode,
  getSecurityCode,
  cancellationUser,
  orderExists,
  getInfoByWordNo,
} from "../../../utils/interface"
import Vcode from "vue-puzzle-vcode"

export default {
  components: {
    Vcode,
  },
  data() {
    return {
      checkedForm: {
        type: [],
      },
      checkedRules: {
        type: [
          {
            type: "array",
            required: true,
            message: "请查看注销协议并勾选",
            trigger: "change",
          },
        ],
      },
      accountShow: false,
      dialogTableVisible: false,
      telephone: "",
      //   获取验证码定时
      canClick: true,
      timeClock: 60,
      clock: null,
      vcodes: false,
      validCode: "",
      validation: false,
      imgUrls: "https://picsum.photos/200/300",
      isExistsLoginTabs: true,
      smsCode: "",
      userPrompt: true,
      orderType: {},
      content: "",
    }
  },
  computed: {
    ...mapState({
      isUsermessage: "isUsermessage",
    }),
  },
  created() {
    this.telephone = this.isUsermessage.tel.replace(
      /^(\d{3})\d*(\d{4})$/,
      "$1****$2"
    )
    this.userMessage()
  },
  methods: {
    // 用户身份判断
    userMessage() {
      orderExists()
        .then((res) => {
          if (res.success) {
            this.orderType = res.data
            this.userPrompt = res.data.buyerOrder
              ? true
              : res.data.designerOrder
              ? true
              : res.data.designerOrder
              ? true
              : false
          }
          console.log("resres", this.orderType)
        })
        .catch((err) => {
          console.log("err", err)
        })
    },
    applyAccount() {
      this.$refs.checkedFormRef.validate((valid) => {
        if (valid) {
          if (!this.userPrompt) {
            this.accountShow = true
          } else {
            this.$message({
              message: "您有未处理事项，请处理后继续销户。",
              type: "warning",
            })
          }
        } else {
          console.log("error submit!!")
          return false
        }
      })
    },
    applyAccountNo() {
      this.$emit("accountShowMess", false)
    },
    // 协议
    protocolDetails() {
      getInfoByWordNo({ wordNo: "ZCYZXXY" }).then((res) => {
        if (res.success) {
          this.content = res.data.content
          this.dialogTableVisible = true
        } else {
          this.$message({
            message: res.message,
            type: "warning",
          })
        }
      })
    },
    // 倒计时60s
    getCountdown() {
      let params = {
        mobile: this.isUsermessage.tel,
        validCode: this.validCode,
      }
      if (this.validCode) {
        getSmscode(params)
          .then((res) => {
            if (res.success) {
              this.canClick = false
              if (this.clock != null) return
              this.clock = window.setInterval(() => {
                if (this.timeClock > 0) {
                  this.timeClock--
                } else if (this.timeClock <= 0) {
                  window.clearInterval(this.clock)
                  this.clock = null
                  this.timeClock = 60
                  this.canClick = true
                }
              }, 1000)
            } else {
              this.$alert(res.message, "提示", {
                confirmButtonText: "确定",
              })
            }
          })
          .catch((err) => {
            console.log(err)
          })
      } else {
        this.$alert("请先进行安全认证", "提示", {
          confirmButtonText: "确定",
        })
        return
      }
    },
    // 用户的验证回调
    onValidation(status, msg) {
      if (status == "yes") {
        // this.vcodes = true;
        let params = { account: this.isUsermessage.tel }
        getSecurityCode(params)
          .then((res) => {
            console.log("res", res)
            this.vcodes = res.success
            this.validCode = res.data
          })
          .catch((err) => {
            console.log(err)
          })
      } else if (status == "no") {
        this.vcodes = false
      }
      this.validation = false // 通过验证后，需要手动隐藏模态框
    },
    // 拼图验证码
    getValidation() {
      this.validation = true
    },
    // 用户点击遮罩层，应该关闭模态框
    onClose() {
      this.validation = false
      this.$message({
        message: "取消验证！",
        type: "warning",
      })
    },
    // 确认注销用户
    onClickCellation() {
      let parems = {
        mobile: this.isUsermessage.tel,
        smsCode: this.smsCode,
      }
      this.$confirm(
        "确认注销账号吗？注销后，账号将被彻底删除，且无法恢复。",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          cancellationUser(parems)
            .then((res) => {
              if (res.success) {
                this.$alert("注销成功", "注销", {
                  confirmButtonText: "确定",
                  callback: (action) => {
                    this.$router.replace("/login")
                  },
                })
              } else {
                this.$message({
                  type: "info",
                  message: "注销用户失败，请重新尝试",
                })
              }
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "注销用户失败，请重新尝试",
              })
            })
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消注销账户操作",
          })
        })
    },
  },
}
</script>

<style lang="less" scoped>
.account {
  margin: 16px 30px;
  h3 {
    margin-bottom: 16px;
  }
  .accountOne {
    .account_mess {
      border-bottom: 1px solid #efefef;
      padding-bottom: 20px;
      margin-bottom: 20px;
      ul {
        line-height: 44px;
        margin-bottom: 10px;
        margin-left: 20px;
        li {
          list-style: disc;
        }
      }
      span {
        color: #2d50a1;
        font-size: 12px;
      }
    }
    .account_mess_num {
      border-bottom: 1px solid #efefef;
      padding-bottom: 20px;
      margin-bottom: 20px;
      .account_mess_title {
        margin-top: 16px;
      }
    }
    .account_mess_ti {
      display: flex;
      align-items: center;
      font-size: 14px;
      color: crimson;
      margin-bottom: 20px;
      margin-top: 16px;
    }
    .account_mess_check {
      display: flex;
      align-items: center;
      .account_mess_checkP {
        font-size: 14px;
        margin-bottom: 5px;
        span {
          color: #2d50a1;
          cursor: pointer;
        }
      }
    }
    .account_mess_btn {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 30px;
      button {
        margin-right: 30px;
      }
      .zhuxiao {
        color: #2d50a1;
        border-color: #2d50a1;
      }
      .quxiao {
        background-color: #2d50a1;
      }
    }
  }
  .accountTwo {
    .account_mess_warn {
      display: flex;
      color: #666;
      font-size: 14px;
      align-items: center;
      i {
        margin-right: 10px;
      }
    }
    .accountTwo_tel {
      margin: 20px 0 40px;
      .accountTwo_tel_num {
        margin: 20px 0;
        input {
          border: 1px solid #efefef;
          height: 30px;
          line-height: 30px;
          padding-left: 5px;
        }
      }
      .accountTwo_telP {
        font-size: 14px;
        color: #666;
      }
      .registered_validation2 {
        background: #3aead336;
        height: 52px;
        margin-bottom: 25px;
        align-items: center;
        color: #777;
        cursor: default;
        justify-content: center;
        color: #6dcaaa;
        border: 1px solid #6dcaaa;

        i {
          font-size: 20px;
          font-weight: bold;
          margin-right: 10px;
        }
      }
      .registered_validation {
        background: #f9f9f9;
        height: 52px;
        margin-bottom: 25px;
        align-items: center;
        color: #777;
        margin-top: 20px;
        width: 47%;
        cursor: pointer;

        img {
          margin: 0 13px;
        }

        .validationVerify {
          z-index: 99;
        }
      }
    }
    .accountTwo_btn {
      display: flex;
      align-items: center;
      button {
        margin-right: 20px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/registeredLogin/securitySettings/cancellationAccount.vue